import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const WhatsAppCredentialList = Loadable(
  lazy(() => import("features/notification/credentialsWhatsApp/components/List"))
);
const WhatsAppCredentialPage = Loadable(
  lazy(() => import("features/notification/credentialsWhatsApp/components/Page"))
);

const routes = {
  path: "whatsapp",
  children: [
    { path: "", element: <WhatsAppCredentialList /> },
    { path: "add", element: <WhatsAppCredentialPage /> },
    { path: "edit/:credentialID?", element: <WhatsAppCredentialPage /> },
  ],
};

export default routes;
